import axios from 'axios';
import { BASE_URL } from '../../../../../Utlils';

// get supplier redirect details :
const fetchSupplierRedirectDetails = async (data) => {
  try {
    const request = await axios.get(
      `${BASE_URL}/suppliers/${data.supplierID}/redirect-details`,
    );

    const json = await request.data;

    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }

    return {
      success: true,
      data: json?.data ?? {},
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};

export const getSupplierRedirectDetails = async ({ supplierID }) => {
  const result = await fetchSupplierRedirectDetails({ supplierID: supplierID });
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

// update supplier redirects :
export const updateSupplierRedirects = async (data) => {
  'use server';
  try {
    const response = await axios.patch(
      `${BASE_URL}/suppliers/${data._id}/update-redirects`,
      data,
    );
    if (response.data?.success) {
      const responseData = await response.data;
      return responseData?.data;
    } else {
      const error = await response.data;
      throw new Error(error?.message || 'An error occurred');
    }
  } catch (error) {
    console.log('error in updateSupplierRedirects', error);
  }
};
